import { ChangeEvent, useEffect, useState } from 'react';
import Header from '../../Common/Header/Header';
import '../../Common/Common/Style.css';
import './Tribe.css';
import { checkSubjectNameExist, checkTribeNameExist, createTribe, deleteTribe, deleteTribeSubject, getAllTribesByOffset, getTribeById, searchTribe, updateTribe } from "../../../api/tribe";
import { useAppDispatch, useAppSelector } from '../../../hooks';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Loader from '../../Common/FullscreenLoader/FullScreenLoader';
import SuccessPopup from '../../Common/MessagePopup/SuccessPopup';
import FailurePoup from '../../Common/MessagePopup/FailurePopup';
import ConfirmationPopup from '../../Common/MessagePopup/ConfirmationPopup';
import { NewSubjectDataType, NewTribeDataType, TribeDataType } from './TribeInterface';
import { Form } from 'react-bootstrap';
import LottieAnimation from '../../Common/LottieAnimation/LottieAnimation';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getNewAccessToken } from '../../../api/auth';
import { setToken } from '../../../reducers/UserSplice';
import CustomAlert from '../../Common/MessagePopup/CustomeAlert';
import { IdAndName, LoadingDataType, MessageDataType } from '../../Common/Common/CommonInterface';
import { Tooltip } from "react-tooltip";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import FullScreenImagePreview from '../../Common/LottieAnimation/FullScreenImagePreview';
import FullScreenLottieAnimation from '../../Common/LottieAnimation/FullScreenLottieAnimation';


const Tribe = () => {
  const dispatch = useAppDispatch();

  const [activeStatus, setActiveStatus] = useState<string>("");
  const [openTribePopup, setOpenTribePopup] = useState<boolean>(false);
  const { access_token, refresh_token } = useAppSelector((state) => state.user.token)
  const [tribe, setTribe] = useState<IdAndName>({ id: "", name: "" })
  const [searchtext, setSearchText] = useState<string>('')
  const [tableTribeData, setTableTribeData] = useState<TribeDataType[]>([]);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showPreview, setShowPreview] = useState<{ imageShow: boolean, animationShow: boolean }>({ imageShow: false, animationShow: false })
  const [tribeCount, setTotalCount] = useState<number>(0);
  const [message, setMessage] = useState<MessageDataType>({
    errorMessage: [],
    successMessage: "",
    failureMessage: ""
  })

  const [loading, setLoading] = useState<LoadingDataType>({
    fetchingLoading: false,
    tableLoading: false,
    deleteLoading: false,
    submitLoading: false,
    validationLoading: false,

  });
  const [tribeData, setTribeData] = useState<NewTribeDataType>({
    id: "",
    tribeName: "",
    tribeIcon: {
      files: "",
      blobPath: "",
      fileExtension: ""
    },
    tribeReward: 0,
    tribeSubject: [
      {
        id: "",
        name: "",
        description: "",
        bannerDescription: "",
        subjectMedia: {
          image: {
            desktop: {
              files: "",
              blobPath: "",
              fileExtension: ""
            }
          },
          video: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          audio: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          popupBanner: {
            files: "",
            blobPath: "",
            fileExtension: ""
          }
        }
      }],
    newTribeSubject: [],
    deleteS3path: [],
    tribeBadgeIcon: {
      files: "",
      blobPath: "",
      fileExtension: ""
    },
    tribeStatus: "",
  });

useEffect(() => {
  const shouldHide = message.errorMessage.length > 0 || openTribePopup;
  document.body.style.overflow = shouldHide ? 'hidden' : 'auto';
  if (!shouldHide) {
    setTimeout(() => {
      document.body.style.overflow = 'auto';
    }, 500)
  }
}, [message.errorMessage.length, openTribePopup]);




  const [confirmationPopupData, setConfirmationPopupData] = useState({
    title: "",
    message: "",
    descriptions: "",
    acceptText: "",
    cancelText: "",
    onAccept: () => { },
    onCancel: () => { },
  });

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const [previewSource, setPreviewSource] = useState<string>("");

  const handleOpenAnimation = (file: any) => {

    if (file instanceof File) {
      const objectURL = URL.createObjectURL(file);
      setPreviewSource(objectURL);

    } else {
      setPreviewSource(file);
    }

    setShowPreview(prev => ({
      ...prev,
      imageShow: false,
      animationShow: true
    }))
  };

  const handleOpenImage = (file: any) => {

    if (file instanceof File) {
      const objectURL = URL.createObjectURL(file);
      setPreviewSource(objectURL);

    } else {

      setPreviewSource(file);
    }
    setShowPreview(prev => ({
      ...prev,
      imageShow: true,
      animationShow: false
    }))
  };

  const handleClosePreview = () => {
    setPreviewSource("")
    setShowPreview(prev => ({
      ...prev,
      animationShow: false,
      imageShow: false
    }))
  };



  const checkFileLimit = (file: File): boolean => {

    switch (file.type) {
      case "video/mp4":
      case "video/webm":
        return file.size <= 250 * 1024 * 1024; // 250 MB

      case "audio/wav":
      case "audio/mpeg": // standard MIME for mp3
        return file.size <= 20 * 1024 * 1024; // 20 MB

      case "image/png":
      case "image/jpeg": // covers both jpg & jpeg
      case "application/json":
      case "image/svg+xml":
        return file.size <= 20 * 1024 * 1024; // 20 MB

      default:
        // fallback (100 MB limit)
        return file.size <= 100 * 1024 * 1024;
    }
  };

  useEffect(() => {
    console.log("Tribe Data ><> ", tribeData)
  }, [tribeData])




  const handleEndDateChange = (date: any) => {
    const currentDate = new Date(); // Get the current date

    if (!startDate) {
      setMessage({
        ...message,
        errorMessage: [
          "Please select a start date before choosing the end date.",
        ],
      });
      return;
    }

    if (date < startDate) {
      setMessage({
        ...message,
        errorMessage: [
          "The end date cannot be earlier than the start date. Please choose a valid end date.",
        ],
      });
      return;
    }

    if (date > currentDate) {
      setMessage({
        ...message,
        errorMessage: [
          "The end date cannot be in the future. Please select a date that is today or earlier.",
        ],
      });
      return;
    }

    setEndDate(date);
  };



  const getAuthorizedToken = async () => {
    try {
      await getNewAccessToken({ refreshToken: refresh_token }).then((newTokenResponse) => {
        const { data, statusCode } = newTokenResponse;
        if (statusCode === 200) {
          dispatch(setToken({
            access_token: data.accessToken,
            refresh_token: data.refreshToken
          }))
        }
      })
    } catch (error: any) {
      console.error("Something went wrong in getting new access Token 163  :: ", error)
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }
    }
  }

  const isLottieJson = (json: any): boolean => {
    return (
      typeof json === 'object' &&
      json !== null &&
      'v' in json &&
      'fr' in json &&
      'ip' in json &&
      'op' in json &&
      'layers' in json
    );
  };

  // Handle image upload
  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, files } = e.target;

    if (!files || files.length === 0) return;

    const file = files?.[0];

    if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg'))) {

      if (checkFileLimit(file)) {
        setTribeData({
          ...tribeData,
          [name]: {
            files: files?.[0],
            blobPath: URL.createObjectURL(files?.[0]),
            fileExtension: files?.[0].name.split('.').pop(),
          }
        })

      } else {
        setMessage({
          ...message,
          errorMessage: ['File Size Exceed. Try to upload within the size limit.']
        });
        return;
      }


    } else if (file && file.type.startsWith("application/json")) {
      if (checkFileLimit(file)) {
        const reader = new FileReader();
        reader.onload = (event) => {
          try {
            const json = JSON.parse(event.target?.result as string);
            if (!isLottieJson(json)) {
              setMessage({
                ...message,
                errorMessage: ['Uploaded JSON is not a valid Lottie JSON animation.']
              })
              return;
            }

            // Proceed to set state if valid
            setTribeData({
              ...tribeData,
              [name]: {
                files: files?.[0],
                blobPath: URL.createObjectURL(files?.[0]),
                fileExtension: files?.[0].name.split('.').pop(),
              }
            })
          } catch (err) {
            setMessage({
              ...message,
              errorMessage: ['Failed to parse JSON file.']
            })
          }
        };
        reader.readAsText(files?.[0]);
        return;

      } else {
        setMessage({
          ...message,
          errorMessage: ['File Size Exceed. Try to upload within the size limit.']
        });
        return;
      }


    } else {
      setMessage({
        ...message,
        errorMessage: ["Unsupported image format. Please upload valid files."]
      });
      return;
    }
  };


  const handleDeleteSubjectById = async (subject: any) => {
    setShow(true)
    setConfirmationPopupData({
      title: `${subject.name ? `Are you sure you want to delete ${subject.name}` : "Are you sure you want to delete?"} `,
      message: "This action cannot be undone.",
      descriptions: `All the lesson associated with ${subject.name} subject will also be deleted.`,
      acceptText: "Delete",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)

        if (subject.id) {
          try {
            setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, validationLoading: false, }))
            await deleteTribeSubject(subject.id, access_token).then((deleteSubjectResponse: any) => {
              const { statusCode } = deleteSubjectResponse;
              if (statusCode === 200) {
                const updatedTribeSubjects = tribeData.tribeSubject.filter((item) => item.id !== subject.id);
                if (updatedTribeSubjects.length > 0) {
                  setTribeData((prevState) => ({
                    ...prevState,
                    tribeSubject: updatedTribeSubjects,
                  }));
                } else {
                  setTribeData((prevState) => ({
                    ...prevState,
                    tribeSubject: updatedTribeSubjects,
                    newTribeSubject: [
                      {
                        id: "",
                        name: "",
                        description: "",
                        bannerDescription: "",
                        subjectMedia: {
                          image: {
                            desktop: {
                              files: "",
                              blobPath: "",
                              fileExtension: ""
                            }
                          },
                          video: {
                            files: "",
                            blobPath: "",
                            fileExtension: ""
                          },
                          audio: {
                            files: "",
                            blobPath: "",
                            fileExtension: ""
                          },
                          popupBanner: {
                            files: "",
                            blobPath: "",
                            fileExtension: ""
                          }
                        }
                      }]
                  }));
                }

              } else if (statusCode === 401) {
                getAuthorizedToken();
                setMessage({
                  ...message,
                  failureMessage: "Authorization token expired. Try again!"
                })
              }
            });
          } catch (error: any) {
            console.error("Something went wrong in getting new access Token 218 :: ", error)
            if (error.response && error.response.data && typeof error.response.data === "string") {
              setMessage({
                ...message,
                failureMessage: error.response.data.message
              })
            } else {
              setMessage({
                ...message,
                failureMessage: "Something went wrong. Please try again"
              })
            }

          } finally {
            setTimeout(() => {
              setMessage(((prev: MessageDataType) => {
                const updatedData = { ...prev };
                updatedData.errorMessage = prev.errorMessage;
                updatedData.failureMessage = "";
                updatedData.successMessage = ""
                return updatedData
              }))

            }, 2500)
            setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          }

        }
      },
      onCancel: handleClose,
    })

  };



  const handleSubjectMedia = (e: any, subject: any, index: number) => {
    try {

      const { name, files } = e.target;
      if (!files || files.length === 0) return;

      const file = files?.[0];




      const fileType = file.type;
      const isImage = fileType.startsWith("image/");
      const isVideo = fileType.startsWith("video/");
      const isAudio = fileType.startsWith("audio/");
      const fileExtension = file.name.toLowerCase().split('.').pop();
      const blobPath = URL.createObjectURL(file);

      let mediaKey: "image" | "video" | "audio" | "popupBanner";
      let mediaData: any = null;



      if (isImage) {
        if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
          if (checkFileLimit(file)) {
            if (name === "popupbanner") {
              mediaKey = "popupBanner";
              mediaData = { files: file, blobPath, fileExtension };
            } else {
              mediaKey = "image";
              mediaData = { desktop: { files: file, blobPath, fileExtension } };
            }
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }
        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported image format. Please upload JPG, PNG, , SVG or JPEG files.']
          });
          return;
        }

      } else if (isVideo) {
        if (file && (file.name.toLowerCase().endsWith('.mp4') || file.name.toLowerCase().endsWith('.webm'))) {
          if (checkFileLimit(file)) {

            mediaKey = "video";
            mediaData = { files: file, blobPath, fileExtension };
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }
        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported video format. Please upload MP4, or WEBP']
          });
          return;
        }

      } else if (isAudio) {

        if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
          if (checkFileLimit(file)) {

            mediaKey = "audio";
            mediaData = { files: file, blobPath, fileExtension };
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }
        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported audio format. Please upload MP3 or WAV files.']
          });
          return;
        }
      }


      // Determine which array to update
      const isExistingSubject = subject.id;
      const useNewTribeSubject = !isExistingSubject && tribeData.id;
      const subjectKey = useNewTribeSubject ? "newTribeSubject" : "tribeSubject";

      setTribeData((prevData) => {
        const updatedSubjects = [...prevData[subjectKey]];
        if (!updatedSubjects[index]) return prevData;

        updatedSubjects[index] = {
          ...updatedSubjects[index],
          subjectMedia: {
            ...updatedSubjects[index].subjectMedia,
            [mediaKey]: {
              ...updatedSubjects[index].subjectMedia?.[mediaKey],
              ...mediaData,
            },
          },
        };

        return {
          ...prevData,
          [subjectKey]: updatedSubjects,
        };
      });
    } catch (error: any) {
      const fallbackMsg = "Something went wrong. Please try again";
      setMessage({
        ...message,
        failureMessage:
          error?.response?.data?.message ?? fallbackMsg,
      });
    }
  };




  const handleDropDown = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;

    setTribeData({
      ...tribeData,
      [name]: value,
    });
  }
  function removeSpans(html: string): string {
    // Remove opening span tags with attributes
    let cleaned = html.replace(/<span[^>]*>/g, "");
    // Remove closing span tags
    cleaned = cleaned.replace(/<\/span>/g, "");
    return cleaned;
  }

  const handleSubjectInput = (name: string, value: string, index: number, subject: string) => {

    if (tribe.id && tribe.name) {
      if (subject === "subject") {
        setTribeData((prevData) => {
          const updatedSubjects = [...prevData.tribeSubject]; // Create a copy of the tribeSubject array
          if (name === "subjectName") {
            // Update the subject at the specified index or append if it doesn't exist
            updatedSubjects[Number(index)].name = value.replace(/[^a-zA-Z0-9 ]/g, "");
          } else if (name === "subjectDescription") {
            updatedSubjects[Number(index)].description = value;
          } else if (name === "bannerDescription") {
            updatedSubjects[Number(index)].bannerDescription = value;
          }
          return {
            ...prevData,
            tribeSubject: updatedSubjects, // Update tribeSubject with the modified array
          };
        });
      } else if (subject === "newSubject") {
        setTribeData((prevData) => {
          const updatedSubjects = [...prevData.newTribeSubject]; // Create a copy of the tribeSubject array
          if (name === "subjectName") {
            // Update the subject at the specified index or append if it doesn't exist
            updatedSubjects[Number(index)].name = value.replace(/[^a-zA-Z0-9 ]/g, "");
          } else if (name === "subjectDescription") {
            updatedSubjects[Number(index)].description = value;
          } else if (name === "bannerDescription") {
            updatedSubjects[Number(index)].bannerDescription = value;
          }
          return {
            ...prevData,
            newTribeSubject: updatedSubjects, // Update tribeSubject with the modified array
          };
        });
      }


    } else {
      setTribeData((prevData) => {
        const updatedSubjects = [...prevData.tribeSubject]; // Create a copy of the tribeSubject array

        if (name === "subjectName") {


          // Update the subject at the specified index or append if it doesn't exist
          updatedSubjects[Number(index)].name = value.replace(/[^a-zA-Z0-9 ]/g, "");


        } else if (name === "subjectDescription") {
          updatedSubjects[Number(index)].description = value;
        } else if (name === "bannerDescription") {
          updatedSubjects[Number(index)].bannerDescription = removeSpans(value);
        }

        return {
          ...prevData,
          tribeSubject: updatedSubjects, // Update tribeSubject with the modified array
        };
      });
    }
  };




  useEffect(() => {
    if (openTribePopup) {
      const handleBeforeUnload = (event: BeforeUnloadEvent) => {
        event.preventDefault();
        event.returnValue = "Are you sure you want to reload? Your changes may be lost."; // Required for modern browsers
      };

      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }

  });





  const handleS3PathDelete = (objectName: string, supportBrowser: string, index: number, s3path: string, file: any) => {
    setShow(true);

    const resetMediaField = (subject: any, type: string) => {
      if (type === "desktop") {
        return {
          ...subject,
          subjectMedia: {
            ...subject.subjectMedia,
            image: {
              ...subject.subjectMedia.image,
              desktop: { files: "", blobPath: "", fileExtension: "" },
            },
          },
        };
      }
      return {
        ...subject,
        subjectMedia: {
          ...subject.subjectMedia,
          [type]: { files: "", blobPath: "", fileExtension: "" },
        },
      };
    };

    setConfirmationPopupData({
      title: `Are you sure you want to delete?`,
      message: "",
      descriptions: "",
      acceptText: "Delete",
      cancelText: "Cancel",
      onAccept: () => {
        setShow(false);

        try {
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, validationLoading: false, }))

          // Case 1: deleting from existing tribeSubject
          if (objectName === "tribeSubject") {
            setTribeData((prevData) => {
              const updatedSubjects = [...prevData.tribeSubject];

              if (updatedSubjects[index]) {
                updatedSubjects[index] = resetMediaField(
                  updatedSubjects[index],
                  supportBrowser
                );
              }

              return {
                ...prevData,
                tribeSubject: updatedSubjects,
                ...(s3path === file && {
                  deleteS3path: [...prevData.deleteS3path, s3path],
                }),
              };
            });
          }
          // Case 2: deleting from newTribeSubject
          else if (objectName === "newTribeSubject") {
            setTribeData((prevData) => {
              const updatedSubjects = [...prevData.newTribeSubject];

              if (updatedSubjects[index]) {
                updatedSubjects[index] = resetMediaField(
                  updatedSubjects[index],
                  supportBrowser
                );
              }

              return {
                ...prevData,
                newTribeSubject: updatedSubjects,
              };
            });
          }
          // Case 3: other top-level media fields
          else {
            setTribeData((prevData) => ({
              ...prevData,
              ...(s3path === file && {
                deleteS3path: [...prevData.deleteS3path, s3path],
              }),
              [objectName]: { files: "", blobPath: "", fileExtension: "" },
            }));
          }
        } finally {
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
        }
      },
      onCancel: handleClose,
    });
  };




  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    let { name, value } = event.target;
    if (name === "tribeReward") {
      setTribeData({
        ...tribeData,
        tribeReward: Number(value) > 0 ? Number(value) : 0, // Use computed property name for the dynamic key
      });
    } else {
      setTribeData({
        ...tribeData,
        [name]: (value).replace(/[^a-zA-Z0-9 ]/g, ""), // Use computed property name for the dynamic key
      });
    }

  };

  const checkTribeName = async () => {
    if (tribeData.tribeName && tribeData.tribeName.trim() !== "") {
      await checkTribeNameExist(tribeData.id, tribeData.tribeName).then((checkTribeNameResponse) => {
        const { message, statusCode } = checkTribeNameResponse;
        if (statusCode === 409) {
          setMessage({
            ...message,
            errorMessage: [message]
          })
          return false;
        }
      })
    }

  }

  const checkSubjectName = async (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (tribeData.id && value && value.trim()) {
      try {
        await checkSubjectNameExist(tribeData.id, value).then((checkSubjectNameResponse) => {
          const { message, statusCode } = checkSubjectNameResponse;
          if (statusCode === 409) {
            setMessage({
              ...message,
              errorMessage: [message]
            })
            return false;
          }
        })
      } catch (error: any) {
        console.error("Check Subject Name Erro ><  ", error)
      }
    }
  };


  const validateForm = async () => {
    const errorMessages: string[] = [];
    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: true, }))
    try {
      const { tribeName, tribeIcon, tribeReward, tribeSubject, newTribeSubject, tribeBadgeIcon, tribeStatus, id } = tribeData;

      // Helper function for validating media files
      const isMediaValid = (media: any) => media && media.files;

      // General validations
      if (!tribeName?.trim()) errorMessages.push("Tribe name is required.");


      // Media validations
      if (!isMediaValid(tribeIcon)) errorMessages.push("Tribe banner is required.");
      if (!isMediaValid(tribeBadgeIcon)) errorMessages.push("Tribe badge icon is required.");

      const allSubjects = [...tribeSubject, ...newTribeSubject];

      allSubjects.forEach((subject, index) => {
        const subjectIndex = index + 1;
        const subjectName = subject.name?.trim() || `Subject ${subjectIndex}`;

        const bannerDescription = subject.bannerDescription?.replace(/<[^>]*>/g, '').trim() || "";
        const hasVideo = !!subject.subjectMedia.video?.files;
        const hasIcon = !!subject.subjectMedia.image?.desktop?.files;
        const hasPopupBanner = !!subject.subjectMedia.popupBanner?.files;
        const hasBannerDescription = !!bannerDescription;
        const hasName = !!subject.name?.trim();
        const hasDescription = !!subject.description?.trim();

        // ✅ Case 1: Video uploaded
        if (hasVideo) {
          const missing: string[] = [];
          if (!hasName) missing.push("Name");
          if (!hasDescription) missing.push("Playbook Description");
          if (!hasIcon) missing.push("Icon");

          if (missing.length > 0) {
            errorMessages.push(`${subjectName}: ${missing.join(", ")} ${missing.length < 2 ? "is" : "are"} required.`);
          }
          return;
        }

        // ✅ Case 2: Popup path chosen
        if (hasPopupBanner || hasBannerDescription) {
          const missing: string[] = [];
          if (!hasName) missing.push("Name");
          if (!hasDescription) missing.push("Playbook Description");
          if (!hasIcon) missing.push("Icon");
          if (!hasPopupBanner) missing.push("Popup Image");
          if (!hasBannerDescription) missing.push("Popup Description");

          if (missing.length > 0) {
            errorMessages.push(`${subjectName}: ${missing.join(", ")} ${missing.length < 2 ? "is" : "are"} required.`);
          }
          return;
        }

        // ✅ Case 3: Partial fields (entered alone or in combination)
        if (hasName || hasDescription || hasIcon) {
          const missing: string[] = [];

          if (!hasName) missing.push("Name");
          if (!hasDescription) missing.push("Playbook Description");
          if (!hasIcon) missing.push("Icon");

          if (missing.length > 0) {
            errorMessages.push(`${subjectName}: ${missing.join(", ")} ${missing.length < 2 ? "is" : "are"} required.`);
          }

          // Banner / Video dependency
          if (!hasBannerDescription && !hasPopupBanner && !hasVideo) {
            errorMessages.push(
              `${subjectName}: Either a Video OR both Popup Image and Popup Description are required.`
            );
          }
          if (hasPopupBanner && !hasBannerDescription) {
            errorMessages.push(`${subjectName}: Popup Description is required.`);
          }
          if (!hasPopupBanner && hasBannerDescription) {
            errorMessages.push(`${subjectName}: Popup Banner is required.`);
          }

          return;
        }
      });







      if (!tribeReward || tribeReward <= 0) errorMessages.push("Tribe reward must be greater than 0.");
      if (!tribeStatus) errorMessages.push("Tribe status must be selected.");

      // If client-side errors already exist, return early
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))

      if (errorMessages.length > 0) {
        setMessage((prev) => ({
          ...prev,
          errorMessage: errorMessages,
        }));
        return false;
      }

      // === Server-side Validations ===
      const { message: tribeNameMessage, statusCode: tribeStatusCode } = await checkTribeNameExist(id, tribeName);
      if (tribeStatusCode === 409) {
        errorMessages.push(tribeNameMessage);
      }

      // Check for subject name conflicts
      if (id) {
        if (newTribeSubject.length > 0) {
          const checkPromises = newTribeSubject.map(async (subject) => {
            if (subject.name.trim()) {
              const { message, statusCode } = await checkSubjectNameExist(id, subject.name);
              if (statusCode === 409) {
                errorMessages.push(`Subject name "${subject.name}" already exists.`);
              }
            }

          });
          await Promise.all(checkPromises);
        }

      } else {
        const nameSet = new Set<string>();
        if (tribeSubject.length > 0) {
          for (const subject of tribeSubject) {
            const name = subject.name?.trim();
            if (name) {
              if (nameSet.has(name)) {
                errorMessages.push(`Duplicate subject name found: ${name}`);
              } else {
                nameSet.add(name);
              }
            }
          }
        }

      }

    } catch (error) {
      //console.error("Error in validateForm:", error);
      setMessage((prev) => ({
        ...prev,
        errorMessage: ["Unexpected error occurred during validation."],
      }));
      return false;

    } finally {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))

      if (errorMessages.length > 0) {
        setMessage((prev) => ({
          ...prev,
          errorMessage: errorMessages,
        }));
        return false;
      }

      return true;
    }
  };

  const handleSubmit = async () => {
    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: true, }))
    if (await validateForm()) {
      setShow(true)
      setConfirmationPopupData({
        title: `Are you sure you want to save?`,
        message: "",
        descriptions: "",
        acceptText: "Yes",
        cancelText: "Cancel",
        onAccept: async () => {
          setShow(false)
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, validationLoading: false, }))
          const formData = new FormData();
          formData.append('name', tribeData.tribeName);
          formData.append('reward', String(tribeData.tribeReward));
          if (tribeData.tribeBadgeIcon.files instanceof File) {
            formData.append('badgeIcon', tribeData.tribeBadgeIcon.files);
          }
          if (tribeData.tribeIcon.files instanceof File) {
            formData.append('icon_animation', tribeData.tribeIcon.files);
          }

          formData.append('published', tribeData.tribeStatus);

          if (tribe.id && tribe.name) {
            formData.append('id', tribeData.id);
            let newSubject: any[] = [];
            if (tribeData.newTribeSubject.length > 0) {
              for (var i = 0; i < tribeData.newTribeSubject.length; i++) {
                if (tribeData.newTribeSubject[i].name) {
                  newSubject.push({ name: tribeData.newTribeSubject[i].name, description: tribeData.newTribeSubject[i].description, banner_desc: tribeData.newTribeSubject[i].bannerDescription });
                  formData.append('files', tribeData.newTribeSubject[i].subjectMedia.image.desktop.files, `subject_new_image_desk_${i}.${tribeData.newTribeSubject[i].subjectMedia.image.desktop.fileExtension}`);
                  formData.append('files', tribeData.newTribeSubject[i].subjectMedia.image.desktop.files, `subject_new_image_mobile_${i}.${tribeData.newTribeSubject[i].subjectMedia.image.desktop.fileExtension}`);
                  tribeData.newTribeSubject[i].subjectMedia.video.files instanceof File && formData.append('files', tribeData.newTribeSubject[i].subjectMedia.video.files, `subject_new_video_${i}.${tribeData.newTribeSubject[i].subjectMedia.video.fileExtension}`);
                  // tribeData.newTribeSubject[i].subjectMedia.video.files instanceof File && formData.append('files', tribeData.newTribeSubject[i].subjectMedia.video.files, `subject_new_video_${i}.${tribeData.newTribeSubject[i].subjectMedia.video.fileExtension}`);
                  tribeData.newTribeSubject[i].subjectMedia.popupBanner.files instanceof File && formData.append('files', tribeData.newTribeSubject[i].subjectMedia.popupBanner.files, `subject_new_banner_${i}.${tribeData.newTribeSubject[i].subjectMedia.popupBanner.fileExtension}`);
                }
              }
            }

            // }

            let updatedExistingSubject: any[] = [];
            const seenIds = new Set(); // To track already processed IDs

            if (tribeData.tribeSubject.length > 0) {
              for (let j = 0; j < tribeData.tribeSubject.length; j++) {
                const subject = tribeData.tribeSubject[j];
                const media = subject.subjectMedia;
                const hasVideo = media.video?.files;
                const hasAudio = media.audio?.files;
                const hasPopupBanner = media.popupBanner?.files;

                // Skip subject if all media are empty
                if (hasVideo && hasAudio && hasPopupBanner) continue;

                // Push subject info once if not already seen
                if (!seenIds.has(subject.id)) {
                  const subjectEntry: any = {
                    id: subject.id,
                    name: subject.name,
                    description: subject.description,
                    banner_desc: subject.bannerDescription,
                  };

                  if (!hasVideo) subjectEntry.video_path = "";
                  if (!hasAudio) subjectEntry.audio_path = "";
                  if (!hasPopupBanner) subjectEntry.banner_desk_path = "";

                  updatedExistingSubject.push(subjectEntry);
                  seenIds.add(subject.id);
                }

                // Append available media files
                if (media.image.desktop.files instanceof File) {
                  formData.append("files", media.image.desktop.files, `subject_image_desk_${j}.${media.image.desktop.fileExtension}`);
                  formData.append("files", media.image.desktop.files, `subject_image_mobile_${j}.${media.image.desktop.fileExtension}`);
                }

                if (media.video.files instanceof File) {
                  formData.append("files", media.video.files, `subject_video_${j}.${media.video.fileExtension}`);
                }

                // if (media.audio.files instanceof File) {
                //   formData.append("files", media.audio.files, `subject_audio_${j}.${media.audio.fileExtension}`);
                // }

                if (media.popupBanner.files instanceof File) {
                  formData.append("files", media.popupBanner.files, `subject_banner_desk_${j}.${media.popupBanner.fileExtension}`);
                }
              }
            }


            if (tribeData.deleteS3path.length > 0) {
              formData.append("removeFiles", JSON.stringify(tribeData.deleteS3path.map((s3path: string) => ({ path: s3path }))));
            }


            if (newSubject.length > 0) {
              formData.append('newSubjects', JSON.stringify(newSubject));
            }

            if (updatedExistingSubject.length > 0) {
              formData.append('subjects', JSON.stringify(updatedExistingSubject));
            }


            try {
              await updateTribe(formData, access_token).then((createTribeResponse) => {
                const { data, statusCode } = createTribeResponse;
                if (statusCode === 200) {
                  setMessage({
                    ...message,
                    successMessage: "Tribe updated successfully!"
                  });
                } else if (statusCode === 401) {
                  getAuthorizedToken();
                  setMessage({
                    ...message,
                    failureMessage: "Authorization token expired. Try again!"
                  })
                }
              })
            } catch (error: any) {
              console.error("Something went wrong in getting new access Token 838 :: ", error)
              if (error.response && error.response.data && typeof error.response.data === "string") {
                setMessage({
                  ...message,
                  failureMessage: error.response.data.message
                })
              } else {
                setMessage({
                  ...message,
                  failureMessage: "Something went wrong. Please try again"
                })
              }

            } finally {
              setOpenTribePopup(false);
              setTimeout(() => {
                setMessage(((prev: MessageDataType) => {
                  const updatedData = { ...prev };
                  updatedData.errorMessage = prev.errorMessage;
                  updatedData.failureMessage = "";
                  updatedData.successMessage = ""
                  return updatedData
                }))

              }, 2500)
              setTribeData({
                id: "",
                tribeName: "",
                tribeIcon: {
                  files: "",
                  blobPath: "",
                  fileExtension: ""
                },
                tribeReward: 0,
                tribeSubject: [
                  {
                    id: "",
                    name: "",
                    description: "",
                    bannerDescription: "",
                    subjectMedia: {
                      image: {
                        desktop: {
                          files: "",
                          blobPath: "",
                          fileExtension: ""
                        }
                      },
                      video: {
                        files: "",
                        blobPath: "",
                        fileExtension: ""
                      },
                      audio: {
                        files: "",
                        blobPath: "",
                        fileExtension: ""
                      },
                      popupBanner: {
                        files: "",
                        blobPath: "",
                        fileExtension: ""
                      }
                    }
                  }],
                newTribeSubject: [],
                deleteS3path: [],
                tribeBadgeIcon: {
                  files: "",
                  blobPath: "",
                  fileExtension: ""
                },
                tribeStatus: "",
              })
              setTribe({
                id: "",
                name: ""
              })
              setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
              setCurrentPage(1)
              getTribe(indexOfFirstItem);


            }
          } else {

            if (tribeData.tribeSubject.length > 0) {
              tribeData.tribeSubject.forEach((subject: NewSubjectDataType, index: number) => {
                if (subject.name) {
                  if (subject.subjectMedia.image.desktop.files instanceof File) {
                    formData.append('files', subject.subjectMedia.image.desktop.files, `subject_image_desk_${index}.${subject.subjectMedia.image.desktop.fileExtension}`);
                    formData.append('files', subject.subjectMedia.image.desktop.files, `subject_image_mobile_${index}.${subject.subjectMedia.image.desktop.fileExtension}`);
                  }
                  if (subject.subjectMedia.video.files instanceof File) {
                    formData.append('files', subject.subjectMedia.video.files, `subject_video_${index}.${subject.subjectMedia.video.fileExtension}`);
                  }

                  // if (subject.subjectMedia.audio.files instanceof File) {
                  //   formData.append('files', subject.subjectMedia.audio.files, `subject_audio_${index}.${subject.subjectMedia.audio.fileExtension}`);
                  // }

                  if (subject.subjectMedia.popupBanner.files instanceof File) {
                    formData.append('files', subject.subjectMedia.popupBanner.files, `subject_banner_desk_${index}.${subject.subjectMedia.popupBanner.fileExtension}`);
                  }
                }
              })
            }


            if (tribeData.tribeSubject.length > 0) {
              formData.append('subjects', JSON.stringify(tribeData.tribeSubject.filter((subject: NewSubjectDataType) => subject.name && subject.name.trim() !== "").map((subject: NewSubjectDataType) => ({ name: subject.name, description: subject.description, banner_desc: subject.bannerDescription }))));
            }

            try {
              await createTribe(formData, access_token).then((createTribeResponse) => {
                const { statusCode } = createTribeResponse;
                if (statusCode === 200) {
                  setMessage({
                    ...message,
                    successMessage: "Tribe added successfully!"
                  });
                } else if (statusCode === 401) {
                  getAuthorizedToken();
                  setMessage({
                    ...message,
                    failureMessage: "Authorization token expired. Try again!"
                  })
                }
              })
            } catch (error: any) {
              console.error("Something went wrong in getting new access Token 885 :: ", error)
              if (error.response && error.response.data && typeof error.response.data === "string") {
                setMessage({
                  ...message,
                  failureMessage: error.response.data.message
                })
              } else {
                setMessage({
                  ...message,
                  failureMessage: "Something went wrong. Please try again"
                })
              }
            } finally {
              setOpenTribePopup(false);
              setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
              setCurrentPage(1);
              getTribe(indexOfFirstItem);
              setTimeout(() => {
                setMessage(((prev: MessageDataType) => {
                  const updatedData = { ...prev };
                  updatedData.errorMessage = prev.errorMessage;
                  updatedData.failureMessage = "";
                  updatedData.successMessage = ""
                  return updatedData
                }))

              }, 2500)
            }
          }



        },
        onCancel: handleClose,
      })
    }


  }

  const handleCancel = () => {
    setShow(true)
    setConfirmationPopupData({
      title: `Are you sure you want to cancel?`,
      message: "This action cannot be undone.",
      descriptions: "",
      acceptText: "Ok",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)
        setTribeData({
          id: "",
          tribeName: "",
          tribeIcon: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          tribeReward: 0,
          tribeSubject: [
            {
              id: "",
              name: "",
              description: "",
              bannerDescription: "",
              subjectMedia: {
                image: {
                  desktop: {
                    files: "",
                    blobPath: "",
                    fileExtension: ""
                  }
                },
                video: {
                  files: "",
                  blobPath: "",
                  fileExtension: ""
                },
                audio: {
                  files: "",
                  blobPath: "",
                  fileExtension: ""
                },
                popupBanner: {
                  files: "",
                  blobPath: "",
                  fileExtension: ""
                }
              }
            }],
          newTribeSubject: [],
          deleteS3path: [],
          tribeBadgeIcon: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          tribeStatus: "",
        })
        setTribe({
          id: "",
          name: ""
        })
        setOpenTribePopup(false);
        getTribe(indexOfFirstItem)
      },
      onCancel: handleClose,
    })
  }

  const handleDeleteSubject = (subject: any, index: number) => {
    // Create a copy of the TribeSubject array
    setShow(true)
    setConfirmationPopupData({
      title: `Are you sure you want to delete ${subject.name}`,
      message: "This action cannot be undone.",
      descriptions: "",
      acceptText: "Delete",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)
        if (tribe.id && tribe.name) {
          const updatedEntries = [...tribeData.newTribeSubject];
          updatedEntries.splice(index, 1)

          // Update the state with the modified array
          setTribeData({
            ...tribeData,
            newTribeSubject: updatedEntries
          })

        } else {
          const updatedEntries = [...tribeData.tribeSubject];

          // Remove the entry at the specified index
          updatedEntries.splice(index, 1);

          // Update the state with the modified array
          setTribeData({
            ...tribeData,
            tribeSubject: updatedEntries
          })


        }
      },
      onCancel: handleClose,
    })



  };

  const handleAddSubject = () => {
    const getValidationErrors = (subjectArray: typeof tribeData.tribeSubject) => {
      const errorMessages: string[] = [];

      if (subjectArray.length === 0) return []; // ✅ No previous entry, allow adding

      const lastEntry = subjectArray[subjectArray.length - 1];
      const subjectName = lastEntry.name?.trim() || "New Subject";

      if (!lastEntry.name?.trim()) {
        errorMessages.push(`Subject Name is required.`);
      }

      // Extract media fields
      const hasVideo = !!lastEntry.subjectMedia.video?.files;
      const hasIcon = !!lastEntry.subjectMedia.image?.desktop?.files;
      const hasPopupBanner = !!lastEntry.subjectMedia.popupBanner?.files;
      const bannerDescription = lastEntry.bannerDescription?.replace(/<[^>]*>/g, '').trim() || "";
      const hasBannerDescription = !!bannerDescription;
      const hasDescription = !!lastEntry.description?.trim();

      // ✅ Case 1: Video uploaded
      if (hasVideo) {
        const missing: string[] = [];
        if (!hasDescription) missing.push("Playbook Description");
        if (!hasIcon) missing.push("Icon");

        if (missing.length > 0) {
          errorMessages.push(`${subjectName}: ${missing.join(", ")} ${missing.length < 2 ? "is" : "are"} required.`);
        }
      }

      // ✅ Case 2: Popup path chosen
      if (hasPopupBanner || hasBannerDescription) {
        const missing: string[] = [];
        if (!hasDescription) missing.push("Playbook Description");
        if (!hasIcon) missing.push("Icon");
        if (!hasPopupBanner) missing.push("Popup Image");
        if (!hasBannerDescription) missing.push("Popup Description");

        if (missing.length > 0) {
          errorMessages.push(`${subjectName}: ${missing.join(", ")} ${missing.length < 2 ? "is" : "are"} required.`);
        }
      }

      // ✅ Case 3: Partial fields (entered alone or in combination)
      if (lastEntry.name?.trim() || hasDescription || hasIcon) {
        const missing: string[] = [];

        if (!hasDescription) missing.push("Playbook Description");
        if (!hasIcon) missing.push("Icon");

        if (missing.length > 0) {
          errorMessages.push(`${subjectName}: ${missing.join(", ")} ${missing.length < 2 ? "is" : "are"} required.`);
        }

        // Banner / Video dependency
        if (!hasBannerDescription && !hasPopupBanner && !hasVideo) {
          errorMessages.push(`${subjectName}: Either a Video OR both Popup Image and Popup Description are required.`);
        }
        if (hasPopupBanner && !hasBannerDescription) {
          errorMessages.push(`${subjectName}: Popup Description is required.`);
        }
        if (!hasPopupBanner && hasBannerDescription) {
          errorMessages.push(`${subjectName}: Popup Banner is required.`);
        }
      }

      return errorMessages;
    };

    setTribeData((prevState) => {
      const targetArray = tribe.id && tribe.name ? prevState.newTribeSubject : prevState.tribeSubject;
      const validationErrors = getValidationErrors(targetArray);

      if (validationErrors.length > 0) {
        setMessage((prev) => ({
          ...prev,
          errorMessage: validationErrors,
        }));
        return prevState; // ❌ Don't add new subject if last is invalid
      }

      const newSubject = {
        id: "",
        name: "",
        description: "",
        bannerDescription: "",
        subjectMedia: {
          image: { desktop: { files: "", blobPath: "", fileExtension: "" } },
          video: { files: "", blobPath: "", fileExtension: "" },
          audio: { files: "", blobPath: "", fileExtension: "" },
          popupBanner: { files: "", blobPath: "", fileExtension: "" }
        }
      };

      return tribe.id && tribe.name
        ? { ...prevState, newTribeSubject: [...prevState.newTribeSubject, newSubject] }
        : { ...prevState, tribeSubject: [...prevState.tribeSubject, newSubject] };
    });
  };




  const [filter, setFilter] = useState<any>({ status: "", dateFilter: "" })
  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;




  const getTribe = async (FirstItemIndex: number) => {
    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    try {
      await getAllTribesByOffset(String(FirstItemIndex), String(itemsPerPage), access_token).then((getAllTribeDataByOffset: any) => {
        const { data, statusCode } = getAllTribeDataByOffset;
        if (statusCode === 200) {
          handleTribeData(data);
        } else if (statusCode === 401) {
          getAuthorizedToken();
          setMessage({
            ...message,
            failureMessage: "Authorization token expired. Try again!"
          })
        } else {
        }
      });
    } catch (error: any) {
      //console.error("Error during tribe search:", error);
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }
    } finally {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      setTimeout(() => {
        setMessage(((prev: MessageDataType) => {
          const updatedData = { ...prev };
          updatedData.errorMessage = prev.errorMessage;
          updatedData.failureMessage = "";
          updatedData.successMessage = ""
          return updatedData
        }))

      }, 2500)

    }
  };



  useEffect(() => {
    getTribe(indexOfFirstItem);
    getGradeData();
  }, []);


  const handlePagination = async (pageNumber: number, direction: string) => {
    if (pageNumber < 1 || pageNumber > Math.ceil(tribeCount / itemsPerPage)) {
      return; // Prevent navigation to invalid pages
    }

    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))

    if (direction === "right") {
      if (pageNumber <= Math.ceil(tribeCount / itemsPerPage)) {
        setCurrentPage(pageNumber);
      }
    } else {
      if (pageNumber >= 1) {
        setCurrentPage(pageNumber);
      }
    }

    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
  };



  useEffect(() => {
    const fetchData = async () => {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      if (activeStatus || searchtext || startDate || endDate) {
        try {
          await searchTribe(searchtext, activeStatus, startDate ? startDate.toISOString().split("T")[0] : null, endDate ? endDate.toISOString().split("T")[0] : null, String(indexOfFirstItem), String(itemsPerPage), access_token).then((searchTribeData) => {
            const { data, statusCode } = searchTribeData;
            if (statusCode === 200) {
              handleTribeData(data);
            } else {
            }
          });
        } catch (error: any) {
          //console.error("Error during tribe search:", error);
          if (error.response && error.response.data && typeof error.response.data === "string") {
            setMessage({
              ...message,
              failureMessage: error.response.data.message
            })
          } else {
            setMessage({
              ...message,
              failureMessage: "Something went wrong. Please try again"
            })
          }

        } finally {
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          setTimeout(() => {
            setMessage(((prev: MessageDataType) => {
              const updatedData = { ...prev };
              updatedData.errorMessage = prev.errorMessage;
              updatedData.failureMessage = "";
              updatedData.successMessage = ""
              return updatedData
            }))

          }, 2500)
        }
      } else {
        getTribe(indexOfFirstItem);
      }
    };



    fetchData();


  }, [currentPage]);


  const getGradeData = async () => {
    try {

      if (tribe.id && tribe.name) {
        setLoading(prev => ({ ...prev, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))

        try {
          const [tribeResponse] = await Promise.all([
            getTribeById(tribe.id, access_token),
          ]);

          const tribeData1 = tribeResponse.data;
          const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

          const getMediaObject = (path: string) => ({
            files: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
            blobPath: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
            fileExtension: getFileExtension(path),
          });


          let subject: NewSubjectDataType[] = [];
          if (tribeData1.subject_id.length > 0) {
            subject = tribeData1.subject_id.map((subject: any) => ({
              id: subject.id,
              name: subject.name,
              description: subject.description,
              bannerDescription: subject.banner_desc,
              subjectMedia: {
                image: {
                  desktop: getMediaObject(subject.image_mobile_path ? subject.image_mobile_path : ""),
                },
                video: getMediaObject(subject.video_path ? subject.video_path : ""),
                audio: getMediaObject(subject.audio_path ? subject.audio_path : ""),
                popupBanner: getMediaObject(subject.banner_desk_path ? subject.banner_desk_path : "")

              },
            }))
          } else {
            subject = []
          }
          setTribeData({
            ...tribeData,
            id: tribeData1.id,
            tribeName: tribeData1.name,
            tribeIcon: getMediaObject(tribeData1.icon_animation_path ? tribeData1.icon_animation_path : ""),
            tribeReward: Number(tribeData1.reward),
            tribeBadgeIcon: getMediaObject(tribeData1.badge_path ? tribeData1.badge_path : ""),
            tribeStatus: String(tribeData1.published),
            tribeSubject: subject,
            newTribeSubject: tribeData1.subject_id.length > 0 ? [] : [
              {
                id: "",
                name: "",
                description: "",
                bannerDescription: "",
                subjectMedia: {
                  image: {
                    desktop: {
                      files: "",
                      blobPath: "",
                      fileExtension: ""
                    }
                  },
                  video: {
                    files: "",
                    blobPath: "",
                    fileExtension: ""
                  },
                  audio: {
                    files: "",
                    blobPath: "",
                    fileExtension: ""
                  },
                  popupBanner: {
                    files: "",
                    blobPath: "",
                    fileExtension: ""
                  }
                }
              }]
          });
        } finally {
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
        }
      }
    } catch (error: any) {
      //console.error("Error fetching data:", error);
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }
    } finally {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    }
  };

  useEffect(() => {
    getGradeData()
  }, [tribe.id])


  const handleEditBtn = (tribe: TribeDataType) => {
    setTribeData({
      id: "",
      tribeName: "",
      tribeIcon: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      tribeReward: 0,
      tribeSubject: [
        {
          id: "",
          name: "",
          description: "",
          bannerDescription: "",
          subjectMedia: {
            image: {
              desktop: {
                files: "",
                blobPath: "",
                fileExtension: ""
              }
            },
            video: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            audio: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            popupBanner: {
              files: "",
              blobPath: "",
              fileExtension: ""
            }
          }
        }],
      newTribeSubject: [],
      deleteS3path: [],
      tribeBadgeIcon: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      tribeStatus: "",
    })
    setOpenTribePopup(true);
    setTribe({ id: tribe.id, name: tribe.name });
    setFilter({ status: "", dateFilter: "" });
    setStartDate(null);
    setEndDate(null);
    setLoading(prev => ({ ...prev, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))



  };

  const handleDelete = async (tribe: TribeDataType) => {
    setShow(true)
    setConfirmationPopupData({
      title: `Are you sure you want to delete ${tribe.name} tribe?`,
      message: "This action cannot be undone.",
      descriptions: `All the lesson associated with ${tribe.name} tribe will also be deleted.`,
      acceptText: "Delete",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, validationLoading: false, }))
        try {
          await deleteTribe(tribe.id, access_token).then((deletedResponse: any) => {
            const { statusCode } = deletedResponse;
            if (statusCode === 200) {
              setMessage({
                errorMessage: [],
                successMessage: "Tribe deleted successfully!",
                failureMessage: ""
              });
            } else if (statusCode === 401) {
              getAuthorizedToken();
              setMessage({
                ...message,
                failureMessage: "Authorization token expired. Try again!"
              })
            } else {
            }
          })
        } catch (error: any) {
          console.error("Error in Delete :: ", error)
          if (error.response && error.response.data && typeof error.response.data === "string") {
            setMessage({
              ...message,
              failureMessage: error.response.data.message
            })
          } else {
            setMessage({
              ...message,
              failureMessage: "Something went wrong. Please try again"
            })
          }
        } finally {
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          setTimeout(() => {
            setMessage(((prev: MessageDataType) => {
              const updatedData = { ...prev };
              updatedData.errorMessage = prev.errorMessage;
              updatedData.failureMessage = "";
              updatedData.successMessage = ""
              return updatedData
            }))

          }, 2500)
          getTribe(indexOfFirstItem);

        }
      },
      onCancel: handleClose,
    })

  }

  const formatLocalDate = (date: Date | null): string | null => {
    if (!date) return null; // Handle null case

    const localDate = new Date(date);
    localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset()); // Adjust for timezone shift

    return localDate.toISOString().split("T")[0]; // Extract YYYY-MM-DD
  };



  const handleFilter = (name: string, value: string | IdAndName) => {
    if (name === "status" && typeof value === "string") {
      setActiveStatus(value ? value : "");

      setFilter((prev: any) => ({
        ...prev,
        status: value === "1" ? "Published" : value === "2" ? "Draft" : value === "0" ? "Unpublished" : ""
      }));
    } else if (name === "date") {
      setFilter({
        ...filter,
        dateFilter: ""
      })
      setStartDate(null)
      setEndDate(null)
    }
  };


  useEffect(() => {
    const handleSearch = async () => {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      setCurrentPage(1);
      if (startDate && endDate) {
        const lang = navigator.language || navigator.languages[0];
        setFilter({
          ...filter,
          dateFilter: `${startDate ? startDate.toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : ""} - ${endDate ? endDate.toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : new Date().toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" })
            }`
        });
      }
      try {

        const searchTribeData = await searchTribe(searchtext, activeStatus, startDate ? formatLocalDate(startDate) : null, (startDate && endDate) ? formatLocalDate(endDate) : null, String(indexOfFirstItem), String(itemsPerPage), access_token);

        const { data, statusCode } = searchTribeData;

        if (statusCode === 200) {
          handleTribeData(data);
        } else if (statusCode === 401) {
          getAuthorizedToken();
          setMessage({
            ...message,
            failureMessage: "Authorization token expired. Try again!"
          })
        }
      } catch (error: any) {
        //console.error("Search Error ::", error);
        if (error.response && error.response.data && typeof error.response.data === "string") {
          setMessage({
            ...message,
            failureMessage: error.response.data.message
          })
        } else {
          setMessage({
            ...message,
            failureMessage: "Something went wrong. Please try again"
          })
        }

      } finally {
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      }
    }

    handleSearch()

  }, [searchtext, startDate, endDate, activeStatus])




  const handleTribeData = (tribeData: any) => {
    try {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      const { tribes, count } = tribeData;
      setTotalCount(Number(count));
      const formattedData = tribes.map((tribe: any) => ({
        id: tribe.id,
        name: tribe.name,
        subject: tribe.subject_id.length,
        lesson: (tribe.lesson_id && tribe.lesson_id.length > 0) ? tribe.lesson_id.length : 0,
        status: tribe.published === 1 ? "PUBLISHED" : (tribe.published === 2 ? "DRAFT" : "UNPUBLISHED"),
        createdAt: tribe.created,
      }));
      setTableTribeData(formattedData);
      // Set the formatted data
    } catch (error: any) {
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }


    } finally {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    }

  }


  const handlePopup = () => {
    setTribe({ id: "", name: "" });
    setTribeData({
      id: "",
      tribeName: "",
      tribeIcon: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      tribeReward: 0,
      tribeSubject: [
        {
          id: "",
          name: "",
          description: "",
          bannerDescription: "",
          subjectMedia: {
            image: {
              desktop: {
                files: "",
                blobPath: "",
                fileExtension: ""
              }
            },
            video: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            audio: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            popupBanner: {
              files: "",
              blobPath: "",
              fileExtension: ""
            }
          }
        }],
      newTribeSubject: [],
      deleteS3path: [],
      tribeBadgeIcon: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      tribeStatus: "",
    });
    setOpenTribePopup(true);
    setFilter({ status: "", dateFilter: "" });
    setStartDate(null);
    setEndDate(null);
  };

  const handlePreview = () => {
    // Open the child window — must be triggered by a direct user interaction
    const win = window.open(process.env.REACT_APP_REDIRECT_WINDOW, "_blank");

    if (!win) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    // Add the message listener immediately
    const handleMessage = (event: MessageEvent) => {
      if (event.origin === process.env.REACT_APP_REDIRECT_WINDOW) {
        window.removeEventListener("message", handleMessage); // Clean up
      } else {
        console.warn("Message blocked from unknown origin:", event.origin);
      }
    };

    window.addEventListener("message", handleMessage);

    // Function to send message when the child window is ready
    const sendMessage = () => {
      try {
        if (win && typeof process.env.REACT_APP_REDIRECT_WINDOW === 'string') {
          win.postMessage({ accessToken: access_token, refreshToken: refresh_token, PreviewTribe: true }, process.env.REACT_APP_REDIRECT_WINDOW);
        } else {
          console.error("Invalid window reference or redirect window URL is not set");
        }

      } catch (error) {
        console.error("Error sending message:", error);
      }
    };

    // Try sending the message a few times to ensure it reaches
    let tries = 0;
    const interval = setInterval(() => {
      if (win.closed) {
        clearInterval(interval);
        return;
      }

      sendMessage();
      tries++;

      if (tries >= 3) {
        clearInterval(interval);
      }
    }, 1000);
  };



  return (
    <div className="dashboard d-flex">
      <Header />
      <div className="rightContainer">
        <div>
          {message.successMessage && <SuccessPopup message={message.successMessage} />}

          {message.failureMessage && <FailurePoup message={message.failureMessage} />}

          <div className="header-container">
            <h2 className="page-title text-center">Tribes</h2>
          </div>
          <div className="pCard">
            <div className="topAction align-items-center">
              <div className="dropdown statusDrop">
                <button className="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                  {/* {activeStatus === "All" ? "Status" : activeStatus === "1" ? "Publish" : activeStatus === "0" ? "Inactive" : "Status"} */}
                  Status
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li><button className={`dropdown-item`} name="status" onClick={() => handleFilter("status", "")}>All</button></li>
                  <li><button className={`dropdown-item ${activeStatus === "1"} ? "active" : ""`} name="status" value="Published" onClick={() => handleFilter("status", "1")} >Published</button></li>
                  <li><button className={`dropdown-item ${activeStatus === "2"} ? "active" : ""`} onClick={() => handleFilter("status", "2")}>Draft</button></li>
                  <li><button className={`dropdown-item ${activeStatus === "0"} ? "active" : ""`} name="status" value="Unpublished" onClick={() => handleFilter("status", "0")}>Unpublished</button></li>
                </ul>

                {filter.status &&
                  <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.status}
                    <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("status", "")} /></span></span>
                }

                {filter.dateFilter &&
                  <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.dateFilter}
                    <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("date", "")} /></span></span>
                }
              </div>

              <div className="dropdown filter ms-auto">
                <a className="dropdown-toggle" href="#blank" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
                  <img src="./assets/images/filter.svg" alt="Filter" />
                </a>
                <div className="dropdown-menu p-3" onClick={(e) => e.stopPropagation()}>
                  {/* <label className="form-label">
                      Select the Date Range
                    </label> */}
                  <div className="mb-3">

                    <DatePicker id="startDate" selected={startDate} onChange={(date) => setStartDate(date)} className="form-control" placeholderText="Date From" />
                  </div>
                  <div className="mb-3">
                    {/* <label htmlFor="endDate" className="form-label">
                      End Date
                    </label> */}
                    <DatePicker id="endDate" selected={endDate} onChange={handleEndDateChange} className="form-control" placeholderText="Date To" />
                  </div>
                </div>
              </div>
              <div className="ms-2 searchInputDashboard">
                <input type="text" placeholder="Search" name="searchText" value={searchtext} onChange={(e) => setSearchText(e.target.value)} />
              </div>

              <button className="btn add-btn btnPurple w-auto px-3" onClick={handlePopup} >+</button>
              <button className="btn add-btn btnPurple w-auto px-3" style={{ fontSize: "14px" }} onClick={handlePreview}>Preview</button>
            </div>
            {loading.tableLoading ?
              <div className="d-flex align-items-center mt-5">
                <div className="loader mx-auto"></div>
              </div> :
              tableTribeData.length > 0 ?
                <div className="table-responsive">
                  <table className="table table-bordered" id="table_with_lessons_data">
                    <thead>
                      <tr>
                        <th className="text-start">TRIBE</th>
                        <th className="text-center"># SUBJECTS</th>
                        <th className="text-center"># LESSONS</th>
                        <th className="text-center">STATUS</th>
                        <th className="text-center">CREATED AT</th>


                        <th className='text-center'>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableTribeData.map((tribe: TribeDataType) => (
                        <tr key={tribe.id}>
                          <td className="text-start">
                            <span data-tooltip-id={`tribe-tooltip-${tribe.id}`} data-tooltip-content={tribe.name} data-tooltip-place="top" >
                              {tribe.name.length > 10 ? tribe.name.substring(0, 10) + "..." : tribe.name}
                            </span>
                            {tribe.name.length > 10 && <Tooltip id={`tribe-tooltip-${tribe.id}`} />}
                          </td>

                          <td className="text-center">{tribe.subject}</td>
                          <td className="text-center">{tribe.lesson}</td>
                          <td className="text-center">
                            <span className={tribe.status === "PUBLISHED" ? "activeStatus" : (tribe.status === "DRAFT" ? "draftStatus" : "inactiveStatus")}>
                              {tribe.status}
                            </span>
                          </td>
                          <td className="text-center">{new Date(tribe.createdAt).toLocaleDateString()}</td>
                          <td className="text-center">
                            <div className="dropdown dots">
                              <button className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src='./assets/images/more.svg' alt='action button' />
                              </button>
                              <ul className="dropdown-menu">
                                <li>
                                  <button className="dropdown-item" onClick={() => handleEditBtn(tribe)}>
                                    <img src="./assets/images/edit-icon.png" alt="" className="me-2" />
                                    Edit
                                  </button>
                                </li>
                                <li>
                                  <button className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDelete(tribe)}>
                                    <img src="./assets/images/delete.png" alt="" className="me-2" />
                                    Delete
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                :
                (!loading.tableLoading && <p className="text-center mt-5">No Data Found</p>)
            }
            {/* Pagination Controls */}
            <div className="pagination-container">

              <nav className='d-flex justify-content-between align-items-center'>
                <div className='page-length'>
                  Showing {Math.min(indexOfFirstItem + 1, tribeCount)} - {Math.min(indexOfLastItem, tribeCount)} of {tribeCount}
                </div>
                <ul className="pagination justify-content-center mx-auto">
                  <li className="page-item">
                    <button className="page-link" onClick={() => handlePagination(currentPage - 1, "left")} aria-label="Previous">
                      <span aria-hidden="true"><img src="./assets/images/arrow-left-small.svg" alt="" /></span>
                    </button>
                  </li>
                  <li className="page-item disabled">
                    <span className="page-link">
                      {indexOfFirstItem + 1} of {indexOfLastItem}
                    </span>
                  </li>
                  <li className="page-item">
                    <button className="page-link" onClick={() => handlePagination(currentPage + 1, "right")} aria-label="Next" >
                      <span aria-hidden="true"><img src="./assets/images/arrow-right-small.svg" alt="" /></span>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <Offcanvas show={openTribePopup} onHide={handleCancel} placement='end' backdrop='static'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className='page-title'>{tribe.name ? <h2>{tribe.name}</h2> : <h2>Create a Tribe</h2>}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="create-tribe">
            <Form noValidate className="create-tribe__form">

              <div className="form-group">
                <h6 className='highlightMediaText'>Tribe Name <span className="text-danger">*</span></h6>
                <input type="text" name="tribeName" className="form-control" placeholder="Tribe Name" value={tribeData.tribeName} onChange={handleInputChange} onBlur={checkTribeName} maxLength={30} required />
                <div className="invalid-feedback" style={{ textAlign: "center" }}>Please provide a valid name.</div>
              </div>

              {/* Tribe Icon */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <h6 className='highlightMediaText'>Tribe Banner <span className="text-danger">*</span></h6>
                    <div className="customImgUpload">
                      <div className="uploadBtn">
                        {tribeData.tribeIcon.files ?
                          <div className="w-100">
                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                              <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                {tribeData.tribeIcon.fileExtension === "json" ?
                                  <div className="imgName" onClick={() => handleOpenAnimation(tribeData.tribeIcon.files)}>
                                    {tribeData.tribeIcon.files instanceof File ? tribeData.tribeIcon.files.name : tribeData.tribeName + " icon"
                                    }
                                  </div> :
                                  <img src={tribeData.tribeIcon.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(tribeData.tribeIcon.files)} />
                                }
                              </div>
                            </div>

                          </div>

                          :
                          <>
                            <img className="noimage" src={"./assets/images/no-image-icon.png"} alt="" />
                            <label htmlFor="customFile1">Click to upload <span>png, jpg, jpeg or json <br />(max 20mb)</span></label>
                            <input type="file" className="form-control d-none" name="tribeIcon" id="customFile1" accept=".png, .jpg, .jpeg, .json" onChange={handleImageUpload} required />
                            <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a tribe icon.</div>
                          </>
                        }

                      </div>
                    </div>
                  </div>
                  {tribeData.tribeIcon.files && <div className="row justify-content-center">
                    <div className="col-auto">
                      <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("tribeIcon", "", -1, tribeData.tribeIcon.blobPath, tribeData.tribeIcon.files)}>
                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                      </button>
                    </div>
                  </div>}
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <h6 className='highlightMediaText'>Tribe Badge <span className="text-danger">*</span></h6>
                    <div className="customImgUpload">
                      <div className="uploadBtn">
                        {tribeData.tribeBadgeIcon.files ?
                          <div className="w-100">
                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                              <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                {tribeData.tribeBadgeIcon.fileExtension === "json" ?
                                  <div className="imgName" onClick={() => handleOpenAnimation(tribeData.tribeBadgeIcon.files)}>
                                    {tribeData.tribeBadgeIcon.files instanceof File ? tribeData.tribeBadgeIcon.files.name : tribeData.tribeName + " badge"
                                    }
                                  </div> :
                                  <img src={tribeData.tribeBadgeIcon.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(tribeData.tribeBadgeIcon.files)} />
                                }

                              </div>
                            </div>
                          </div>
                          :
                          <>
                            <img className="noimage" src={"./assets/images/no-image-icon.png"} alt="" />
                            <label htmlFor="customBadgeIconFile">Click to upload <span>png, jpg, jpeg or json <br />(max 20mb)</span></label>
                            <input type="file" className="form-control d-none" name="tribeBadgeIcon" id="customBadgeIconFile" accept=".json, .png, .jpg, .jpeg" onChange={handleImageUpload} required />
                            <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a badge.</div>
                          </>
                        }
                      </div>
                    </div>
                  </div>
                  {tribeData.tribeBadgeIcon.files && <div className="row justify-content-center">
                    <div className="col-auto">
                      <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("tribeBadgeIcon", "", -1, tribeData.tribeBadgeIcon.blobPath, tribeData.tribeBadgeIcon.files)}>
                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                      </button>
                    </div>
                  </div>}
                </div>
              </div>

              <div className="form-group">

                <div style={{ paddingLeft: "3%" }}>
                  <h6 className='highlightMediaText'>Add Subject</h6>
                  {/* Add Subject  */}
                  {tribe.id ? (
                    tribeData.tribeSubject.length > 0 ?
                      (
                        <div>
                          <div className="accordion formAcc mb-3" id="accordionSubject">
                            {tribeData.tribeSubject.map((subject, index) => (
                              <div className='mb-3' key={index}>
                                <div className="accordion-item p-2" style={{ backgroundColor: "#F0F2F6", borderRadius: "18px" }}>
                                  <h2 className="accordion-header" id={`heading${index}`}>
                                    <div className="row">
                                      <div className="col-md-10">
                                        <button className="form-control accordion-button collapsed border-0 bg-transparent" type="button" data-bs-toggle="collapse" style={{ backgroundColor: "#F0F2F6", borderRadius: "15px", border: "0px" }} data-bs-target={`#collapse${index}`} aria-expanded={index === 0 ? "true" : "false"} aria-controls={`collapse${index}`} >
                                          {subject.name}
                                        </button>
                                      </div>
                                      <div className="col-md-2 my-auto d-flex justify-content-between" style={{ border: "0" }}>
                                        {tribeData.tribeSubject.length - 1 === index && tribeData.newTribeSubject.length < 1 &&
                                          <button className="btn p-0" style={{ border: "none" }} type="button" id="button-addon2" onClick={handleAddSubject}>
                                            <img src="./assets/images/add-icon.svg" alt="Add" />
                                          </button>
                                        }
                                        <button className="btn p-0" name={subject.id} type="button" id="button-addon2" onClick={() => handleDeleteSubjectById(subject)}>
                                          <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                        </button>


                                      </div>
                                    </div>
                                  </h2>
                                  <div id={`collapse${index}`} className={`accordion-collapse collapse`} aria-labelledby={`heading${index}`} data-bs-parent="#accordionSubject" >
                                    <div className="accordion-body">
                                      <div className="col-md-10 mb-3">
                                        <h6 className='highlightMediaText'>Playbook Description</h6>
                                        <textarea rows={6} name="subjectDescription" placeholder={`Subject ${index + 1} Playbook Description`} value={subject.description} style={{ backgroundColor: "#D9DDEA", borderRadius: "15px", height: "100%" }} onChange={(e) => handleSubjectInput("subjectDescription", e.target.value, index, "subject")} />
                                      </div>
                                      <div className="row">
                                        <div className="col-md-5">
                                          <div className="form-group">
                                            <h6 className='highlightMediaText'>Icon <span className="text-danger">*</span></h6>
                                            <div className="customImgUpload" style={{ backgroundColor: "#D9DDEA", borderRadius: "15px" }}>
                                              <div className="uploadBtn">
                                                {subject.subjectMedia.image.desktop.blobPath ?
                                                  <div className="w-100">
                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                      <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                        <img src={subject.subjectMedia.image.desktop.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(subject.subjectMedia.image.desktop.files)} />

                                                      </div>
                                                    </div>

                                                  </div>
                                                  :
                                                  <>
                                                    <img className="noimage" src={"./assets/images/no-image-icon.png"} alt="" />
                                                    <label htmlFor={`customFile1-${index}`}>
                                                      Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                                    </label>
                                                    <input type="file" className="form-control d-none" id={`customFile1-${index}`} name={`desktop`} accept=".png, .jpg, .jpeg" onChange={(e) => handleSubjectMedia(e, subject, index)} required />
                                                    <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a banner.</div>
                                                  </>

                                                }

                                              </div>
                                            </div>
                                          </div>
                                          {subject.subjectMedia.image.desktop.files && <div className="row justify-content-center">
                                            <div className="col-auto">
                                              <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("tribeSubject", "desktop", index, subject.subjectMedia.image.desktop.blobPath, subject.subjectMedia.image.desktop.files)}>
                                                <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                              </button>
                                            </div>
                                          </div>}
                                        </div>
                                        <div className="col-md-5" style={{
                                          display: ((subject.bannerDescription.replace(/<[^>]*>/g, '').trim() !== "" || subject.subjectMedia.popupBanner.files) && !subject.subjectMedia.video.files) ? "none" : "",
                                        }}>
                                          <div className="form-group">
                                            <h6 className='highlightMediaText'>Video</h6>
                                            <div className="customImgUpload" style={{ backgroundColor: "#D9DDEA", borderRadius: "15px" }}>
                                              <div className="uploadBtn">
                                                {subject.subjectMedia.video.files ?
                                                  <div className="w-100">
                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                      <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                        <video controls style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh", margin: "0 auto" }} >
                                                          <source src={subject.subjectMedia.video.blobPath} type="video/mp4" />
                                                          Your browser does not support the video tag.
                                                        </video>

                                                      </div>
                                                    </div>

                                                  </div>
                                                  : (
                                                    <>
                                                      <img className="noimage" src="./assets/images/no-image-icon.png" alt="No content available" />
                                                      <label htmlFor={`introVideo-${index}`}>
                                                        Click to upload <span>mp4 or webm <br />(max 250mb)</span>
                                                      </label>
                                                      <input type="file" className="form-control d-none" name={`video`} id={`introVideo-${index}`} accept=".mp4, .webm" onChange={(e) => handleSubjectMedia(e, subject, index)} required />
                                                      <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a intro video.</div>

                                                    </>
                                                  )
                                                }
                                              </div>
                                            </div>
                                          </div>
                                          {subject.subjectMedia.video.files && <div className="row justify-content-center">
                                            <div className="col-auto">
                                              <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("tribeSubject", "video", index, subject.subjectMedia.video.blobPath, subject.subjectMedia.video.files)}>
                                                <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                              </button>
                                            </div>
                                          </div>}
                                        </div>
                                      </div>

                                      <div className="row" style={((!subject.bannerDescription.replace(/<[^>]*>/g, '').trim() || !subject.subjectMedia.popupBanner.files) && subject.subjectMedia.video.files) ? { display: "none" } : {}}>
                                        <div className="col-md-5">
                                          <div className="form-group" >
                                            <div className="form-group">
                                              <h6 className='highlightMediaText'>Popup Image</h6>
                                              <div className="customImgUpload" style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                                <div className="uploadBtn">
                                                  {subject.subjectMedia.popupBanner.files ?
                                                    <div className="w-100">
                                                      <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                        <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                          <img src={subject.subjectMedia.popupBanner.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(subject.subjectMedia.popupBanner.files)} />
                                                        </div>
                                                      </div>

                                                    </div>
                                                    :
                                                    <>
                                                      <img className="noimage" src={"./assets/images/no-image-icon.png"} alt="" />
                                                      <label htmlFor={`popup-banner-${index}`}>
                                                        Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                                      </label>
                                                      <input type="file" className="form-control d-none" id={`popup-banner-${index}`} name="popupbanner" accept=".png, .jpg, .jpeg" onChange={(e) => handleSubjectMedia(e, subject, index)} required />
                                                      <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload the banner.</div>
                                                    </>
                                                  }

                                                </div>
                                              </div>
                                            </div>
                                            {subject.subjectMedia.popupBanner.files && <div className="row justify-content-center">
                                              <div className="col-auto">
                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("tribeSubject", "popupBanner", index, subject.subjectMedia.popupBanner.blobPath, subject.subjectMedia.popupBanner.files)} >
                                                  <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                </button>
                                              </div>
                                            </div>}
                                          </div>
                                        </div>
                                        <div className="col-md-6">
                                          <div className="form-group">
                                            <h6 className='highlightMediaText'>Popup Description</h6>
                                            <ReactQuill className='whitebg' id={`bannerdescription-${index}`} value={subject.bannerDescription} onChange={(value) => handleSubjectInput("bannerDescription", value, index, "subject")}
                                              style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }} modules={{
                                                toolbar: [
                                                  [{ header: [3, 4, false] }],
                                                  ["bold", "italic", "underline", "blockquote"],
                                                  [
                                                    { list: "ordered" },
                                                    { list: "bullet" },
                                                    { indent: "-1" },
                                                    { indent: "+1" }
                                                  ],
                                                  [{ align: [] }]
                                                ]
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          {tribeData.newTribeSubject.map((newSubject, index) => (
                            <div key={index} className='p-2' style={{
                              backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#F0F2F6" : "#FFFFFF",
                              borderRadius: "15px"
                            }}>
                              <div className="row mb-3 form-group" style={{ marginBottom: "0" }}>
                                <div className="col-md-10">
                                  <input type="text" className="form-control" placeholder={`Subject ${tribeData.tribeSubject.length + index + 1} Name`} name={`name`} value={newSubject.name || ""} onChange={(e) => handleSubjectInput("subjectName", e.target.value, index, "newSubject")} onBlur={checkSubjectName} maxLength={30} required />
                                </div>
                                <div className="col-2 my-auto">
                                  <div className="d-flex justify-content-between h-100">
                                    {index === tribeData.newTribeSubject.length - 1 && (
                                      <button className="btn p-0" type="button" id="button-addon2" onClick={handleAddSubject} >
                                        <img src="./assets/images/add-icon.svg" alt="Add" />
                                      </button>
                                    )}

                                    {index !== tribeData.newTribeSubject.length - 1 && (
                                      <button className="btn p-0" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseNewSuject${index}`} aria-expanded="false" aria-controls={`collapseNewSuject${index}`}>
                                        <img width="24" src="./assets/images/down-arrow.png" alt="" />
                                      </button>
                                    )}

                                    <button className="btn p-0" type="button" id="button-addon2" onClick={() => handleDeleteSubject(newSubject, index)} >
                                      <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                    </button>


                                  </div>
                                </div>
                              </div>

                              <div className={`accordion-body ${(tribeData.newTribeSubject.length - 1) === index ? "show" : "collapse"}`} id={`collapseNewSuject${index}`}>
                                <div className="col-md-10 mb-3">
                                  <h6 className='highlightMediaText'>Playbook Description</h6>
                                  <textarea rows={6} name="subjectDescription" style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px", height: "100%" }} placeholder={`Subject ${tribeData.tribeSubject.length + index + 1} Playbook Description`} value={newSubject.description} onChange={(e) => handleSubjectInput("subjectDescription", e.target.value, index, "newSubject")} />
                                </div>
                                <div className="row">
                                  <div className="col-md-5">
                                    <div className="form-group">
                                      <h6 className='highlightMediaText'>Icon <span className="text-danger">*</span></h6>
                                      <div className="customImgUpload" style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                        <div className="uploadBtn">
                                          {newSubject.subjectMedia.image.desktop.files ?
                                            <div className="w-100">
                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                  <img src={newSubject.subjectMedia.image.desktop.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(newSubject.subjectMedia.image.desktop.files)} />

                                                </div>
                                              </div>

                                            </div>
                                            :
                                            <>
                                              <img className="noimage" src={"./assets/images/no-image-icon.png"} alt="" />
                                              <label htmlFor={`customFile1-${index}`}>
                                                Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                              </label>
                                              <input type="file" className="form-control d-none" id={`customFile1-${index}`} name={`desktop`} accept=".png, .jpg, .jpeg" onChange={(e) => handleSubjectMedia(e, newSubject, index)} required />
                                              <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload the banner</div>
                                            </>
                                          }

                                        </div>
                                      </div>
                                    </div>

                                    {newSubject.subjectMedia.image.desktop.files && <div className="row justify-content-center">
                                      <div className="col-auto">
                                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("newTribeSubject", "desktop", index, newSubject.subjectMedia.image.desktop.blobPath, newSubject.subjectMedia.image.desktop.files)}>
                                          <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                        </button>
                                      </div>
                                    </div>}
                                  </div>
                                  <div className="col-md-5" style={{
                                    display: ((newSubject.bannerDescription.replace(/<[^>]*>/g, '').trim() !== "" || newSubject.subjectMedia.popupBanner.files) && !newSubject.subjectMedia.video.files) ? "none" : "",
                                  }}>
                                    <div className="form-group">
                                      <h6 className='highlightMediaText'>Video</h6>
                                      <div className="customImgUpload" style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                        <div className="uploadBtn">
                                          {newSubject.subjectMedia.video.files ?
                                            <div className="w-100">
                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                  <video controls style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh", margin: "0 auto" }} >
                                                    <source src={newSubject.subjectMedia.video.blobPath} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                  </video>

                                                </div>
                                              </div>

                                            </div>
                                            : (
                                              <>
                                                <img className="noimage" src="./assets/images/no-image-icon.png" alt="No content available" />
                                                <label htmlFor={`introVideo-${index}`}>
                                                  Click to upload <span>mp4 or webm <br />(max 250mb)</span>
                                                </label>
                                                <input type="file" className="form-control d-none" name={`video`} id={`introVideo-${index}`} accept=".mp4, .webm" onChange={(e) => handleSubjectMedia(e, newSubject, index)} required />
                                                <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a intro video.</div>
                                              </>
                                            )
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    {newSubject.subjectMedia.video.files && <div className="row justify-content-center">
                                      <div className="col-auto">
                                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("newTribeSubject", "video", index, newSubject.subjectMedia.video.blobPath, newSubject.subjectMedia.video.files)}>
                                          <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                        </button>
                                      </div>
                                    </div>}
                                  </div>
                                </div>

                                <div className="row" style={((!newSubject.bannerDescription.replace(/<[^>]*>/g, '').trim() || !newSubject.subjectMedia.popupBanner.files) && newSubject.subjectMedia.video.files) ? { display: "none" } : {}}>
                                  <div className="col-md-5">
                                    <div className="form-group" >
                                      <div className="form-group">
                                        <h6 className='highlightMediaText'>Popup Image</h6>
                                        <div className="customImgUpload" style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                          <div className="uploadBtn">
                                            {newSubject.subjectMedia.popupBanner.files ?
                                              <div className="w-100">
                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                  <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                    <img src={newSubject.subjectMedia.popupBanner.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(newSubject.subjectMedia.popupBanner.files)} />
                                                  </div>
                                                </div>

                                              </div>
                                              :
                                              <>
                                                <img className="noimage" src={"./assets/images/no-image-icon.png"} alt="" />
                                                <label htmlFor={`popup-banner-${index}`}>
                                                  Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                                </label>
                                                <input type="file" className="form-control d-none" id={`popup-banner-${index}`} name="popupbanner" accept=".png, .jpg, .jpeg" onChange={(e) => handleSubjectMedia(e, newSubject, index)} required />
                                                <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload the banner.</div>
                                              </>
                                            }

                                          </div>
                                        </div>
                                      </div>
                                      {newSubject.subjectMedia.popupBanner.files && <div className="row justify-content-center">
                                        <div className="col-auto">
                                          <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("newTribeSubject", "popupBanner", index, newSubject.subjectMedia.popupBanner.blobPath, newSubject.subjectMedia.popupBanner.files)} >
                                            <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                          </button>
                                        </div>
                                      </div>}
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <h6 className='highlightMediaText'>Popup Description</h6>
                                      <ReactQuill className='whitebg' id={`bannerdescription-${index}`} value={newSubject.bannerDescription} onChange={(value) => handleSubjectInput("bannerDescription", value, index, "subject")}
                                        style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }} modules={{
                                          toolbar: [
                                            [{ header: [3, 4, false] }],
                                            ["bold", "italic", "underline", "blockquote"],
                                            [
                                              { list: "ordered" },
                                              { list: "bullet" },
                                              { indent: "-1" },
                                              { indent: "+1" }
                                            ],
                                            [{ align: [] }]
                                          ]
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>





                              </div>
                            </div>
                          ))}

                        </div>
                      ) : (
                        <div>
                          {tribeData.newTribeSubject.map((newSubject, index) => (
                            <div key={index}>
                              <div className="row mb-3 form-group" style={{ marginBottom: "0" }}>
                                <div className="col-md-10">
                                  <input type="text" className="form-control" placeholder={`Subject ${index + 1} Name`} name={`name`} value={newSubject.name || ""} onChange={(e) => handleSubjectInput("subjectName", e.target.value, index, "newSubject")} onBlur={checkSubjectName} maxLength={30} required />
                                </div>
                                <div className="col-auto my-auto">
                                  <div className="d-flex justify-content-between h-100">
                                    {index === tribeData.newTribeSubject.length - 1 && (
                                      <button className="btn p-0" type="button" id="button-addon2" onClick={handleAddSubject} >
                                        <img src="./assets/images/add-icon.svg" alt="Add" />
                                      </button>
                                    )}
                                    {index !== tribeData.newTribeSubject.length - 1 && (

                                      <button className="btn p-0" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseSuject${index}`} aria-expanded="false" aria-controls={`collapseSuject${index}`}>
                                        <img width="24" src="./assets/images/down-arrow.png" alt="" />
                                      </button>
                                    )}
                                    {tribeData.newTribeSubject.length > 1 && (
                                      <button className="btn p-0" type="button" id="button-addon2" onClick={() => handleDeleteSubject(newSubject, index)} >
                                        <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className={`accordion-body ${(tribeData.newTribeSubject.length - 1) === index ? "show" : "collapse"}`} id={`collapseSuject${index}`}>
                                <div className="col-md-10 mb-3">
                                  <h6 className='highlightMediaText'>Playbook Description</h6>
                                  <textarea rows={6} name="subjectDescription" placeholder={`Subject ${tribeData.tribeSubject.length + index + 1} Playbook Description`} style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px", height: "100%" }} value={newSubject.description} onChange={(e) => handleSubjectInput("subjectDescription", e.target.value, index, "newSubject")} />
                                </div>

                                <div className="row">
                                  <div className="col-md-5">
                                    <div className="form-group">
                                      <h6 className='highlightMediaText'>Icon <span className="text-danger">*</span></h6>
                                      <div className="customImgUpload" style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                        <div className="uploadBtn">
                                          {newSubject.subjectMedia.image.desktop.files ?
                                            <div className="w-100">
                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                  <img src={newSubject.subjectMedia.image.desktop.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(newSubject.subjectMedia.image.desktop.files)} />

                                                </div>
                                              </div>

                                            </div>
                                            :
                                            <>
                                              <img className="noimage" src={"./assets/images/no-image-icon.png"} alt="" />
                                              <label htmlFor={`customFile1-${index}`}>
                                                Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                              </label>
                                              <input type="file" className="form-control d-none" id={`customFile1-${index}`} name={`desktop`} accept=".png, .jpg, .jpeg" onChange={(e) => handleSubjectMedia(e, newSubject, index)} required />
                                              <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload the banner.</div>
                                            </>
                                          }

                                        </div>
                                      </div>
                                    </div>
                                    {newSubject.subjectMedia.image.desktop.files && <div className="row justify-content-center">
                                      <div className="col-auto">
                                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("newTribeSubject", "desktop", index, newSubject.subjectMedia.image.desktop.blobPath, newSubject.subjectMedia.image.desktop.files)} >
                                          <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                        </button>
                                      </div>
                                    </div>}
                                  </div>
                                  <div className="col-md-5" style={{
                                    display: ((newSubject.bannerDescription.replace(/<[^>]*>/g, '').trim() !== "" || newSubject.subjectMedia.popupBanner.files) && !newSubject.subjectMedia.video.files) ? "none" : "",
                                  }}>
                                    <div className="form-group">
                                      <h6 className='highlightMediaText'>Video</h6>
                                      <div className="customImgUpload" style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                        <div className="uploadBtn">
                                          {newSubject.subjectMedia.video.files ?
                                            <div className="w-100">
                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                  <video controls style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh", margin: "0 auto" }} >
                                                    <source src={newSubject.subjectMedia.video.blobPath} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                  </video>

                                                </div>
                                              </div>

                                            </div>
                                            : (
                                              <>
                                                <img className="noimage" src="./assets/images/no-image-icon.png" alt="No content available" />
                                                <label htmlFor={`introVideo-${index}`}>
                                                  Click to upload <span>mp4 or webm <br />(max 250mb)</span>
                                                </label>
                                                <input type="file" className="form-control d-none" name={`video`} id={`introVideo-${index}`} accept=".mp4, .webm" onChange={(e) => handleSubjectMedia(e, newSubject, index)} required />
                                                <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a intro video.</div>
                                              </>
                                            )
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    {newSubject.subjectMedia.video.files && <div className="row justify-content-center">
                                      <div className="col-auto">
                                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("newTribeSubject", "video", index, newSubject.subjectMedia.video.blobPath, newSubject.subjectMedia.video.files)}>
                                          <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                        </button>
                                      </div>
                                    </div>}
                                  </div>

                                  <div className="row" style={((!newSubject.bannerDescription.replace(/<[^>]*>/g, '').trim() || !newSubject.subjectMedia.popupBanner.files) && newSubject.subjectMedia.video.files) ? { display: "none" } : {}}>
                                    <div className="col-md-5">
                                      <div className="form-group" >
                                        <div className="form-group">
                                          <h6 className='highlightMediaText'>Popup Image</h6>
                                          <div className="customImgUpload" style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                            <div className="uploadBtn">
                                              {newSubject.subjectMedia.popupBanner.files ?
                                                <div className="w-100">
                                                  <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                    <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                      <img src={newSubject.subjectMedia.popupBanner.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(newSubject.subjectMedia.popupBanner.files)} />
                                                    </div>
                                                  </div>

                                                </div>
                                                :
                                                <>
                                                  <img className="noimage" src={"./assets/images/no-image-icon.png"} alt="" />
                                                  <label htmlFor={`popup-banner-${index}`}>
                                                    Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                                  </label>
                                                  <input type="file" className="form-control d-none" id={`popup-banner-${index}`} name="popupbanner" accept=".png, .jpg, .jpeg" onChange={(e) => handleSubjectMedia(e, newSubject, index)} required />
                                                  <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload the banner.</div>
                                                </>
                                              }

                                            </div>
                                          </div>
                                        </div>
                                        {newSubject.subjectMedia.popupBanner.files && <div className="row justify-content-center">
                                          <div className="col-auto">
                                            <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("newTribeSubject", "popupBanner", index, newSubject.subjectMedia.popupBanner.blobPath, newSubject.subjectMedia.popupBanner.files)} >
                                              <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                            </button>
                                          </div>
                                        </div>}
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <h6 className='highlightMediaText'>Popup Description</h6>
                                        <ReactQuill className='whitebg' id={`bannerdescription-${index}`} value={newSubject.bannerDescription} onChange={(value) => handleSubjectInput("bannerDescription", value, index, "subject")}
                                          style={{ backgroundColor: tribeData.newTribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }} modules={{
                                            toolbar: [
                                              [{ header: [3, 4, false] }],
                                              ["bold", "italic", "underline", "blockquote"],
                                              [
                                                { list: "ordered" },
                                                { list: "bullet" },
                                                { indent: "-1" },
                                                { indent: "+1" }
                                              ],
                                              [{ align: [] }]
                                            ]
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )
                  ) : (
                    // When adding new tribe
                    <div>
                      {tribeData.tribeSubject.map((subject, index) => (
                        <div key={index}>
                          <div className="row mb-3 form-group" style={{ marginBottom: "0" }}>
                            <div className="col-md-10">
                              <input type="text" className="form-control" placeholder={`Subject ${index + 1} Name`} name={`name`} value={subject.name || ""} onChange={(e) => handleSubjectInput("subjectName", e.target.value, index, "subject")} onBlur={checkSubjectName} maxLength={30} required />
                            </div>
                            <div className="col-auto my-auto">
                              <div className="d-flex justify-content-between h-100">
                                {index === tribeData.tribeSubject.length - 1 && (
                                  <button className="btn p-0" type="button" id="button-addon2" onClick={handleAddSubject} >
                                    <img src="./assets/images/add-icon.svg" alt="Add" />
                                  </button>
                                )}
                                {index !== tribeData.tribeSubject.length - 1 && (
                                  <button className="btn p-0" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseSuject${index}`} aria-expanded="false" aria-controls={`collapseSuject${index}`}>
                                    <img width="24" src="./assets/images/down-arrow.png" alt="" />
                                  </button>
                                )}
                                {tribeData.tribeSubject.length > 1 && (
                                  <button className="btn p-0" type="button" id="button-addon2" onClick={() => handleDeleteSubject(subject, index)} >
                                    <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className={`accordion-body ${(tribeData.tribeSubject.length - 1) === index ? "show" : "collapse"}`} id={`collapseSuject${index}`}>
                            <div className="col-md-10 mb-3">
                              <h6 className='highlightMediaText'>Playbook Description</h6>
                              <textarea rows={6} name="subjectDescription" placeholder={`Subject ${index + 1} Playbook Description`} value={subject.description} style={{ backgroundColor: tribeData.tribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px", height: "100%" }} onChange={(e) => handleSubjectInput("subjectDescription", e.target.value, index, "subject")} />
                            </div>
                            <div className="row">
                              <div className="col-md-5">
                                <div className="form-group">
                                  <h6 className='highlightMediaText'>Icon <span className="text-danger">*</span></h6>
                                  <div className="customImgUpload" style={{ backgroundColor: tribeData.tribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                    <div className="uploadBtn">
                                      {subject.subjectMedia.image.desktop.files ?
                                        <div className="w-100">
                                          <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                            <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                              <img src={subject.subjectMedia.image.desktop.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(subject.subjectMedia.image.desktop.files)} />

                                            </div>
                                          </div>

                                        </div>
                                        :
                                        <>
                                          <img className="noimage" src={"./assets/images/no-image-icon.png"} alt="" />
                                          <label htmlFor={`customFile1-${index}`}>
                                            Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                          </label>
                                          <input type="file" className="form-control d-none" id={`customFile1-${index}`} name={`desktop`} accept=".png, .jpg, .jpeg" onChange={(e) => handleSubjectMedia(e, subject, index)} required />
                                          <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload the banner.</div>
                                        </>
                                      }

                                    </div>
                                  </div>
                                </div>
                                {subject.subjectMedia.image.desktop.files && <div className="row justify-content-center">
                                  <div className="col-auto">
                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("tribeSubject", "desktop", index, subject.subjectMedia.image.desktop.blobPath, subject.subjectMedia.image.desktop.files)}>
                                      <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                    </button>
                                  </div>
                                </div>}
                              </div>
                              <div className="col-md-5" style={{
                                display: ((subject.bannerDescription.replace(/<[^>]*>/g, '').trim() !== "" || subject.subjectMedia.popupBanner.files) && !subject.subjectMedia.video.files) ? "none" : "",
                              }}>
                                <div className="form-group">
                                  <h6 className='highlightMediaText'>Video</h6>
                                  <div className="customImgUpload" style={{ backgroundColor: tribeData.tribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                    <div className="uploadBtn">
                                      {subject.subjectMedia.video.files ?
                                        <div className="w-100">
                                          <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                            <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                              <video controls style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh", margin: "0 auto" }} >
                                                <source src={subject.subjectMedia.video.blobPath} type="video/mp4" />
                                                Your browser does not support the video tag.
                                              </video>

                                            </div>
                                          </div>

                                        </div>
                                        : (
                                          <>
                                            <img className="noimage" src="./assets/images/no-image-icon.png" alt="No content available" />
                                            <label htmlFor={`introVideo-${index}`}>
                                              Click to upload <span>mp4 or webm <br />(max 250mb)</span>
                                            </label>
                                            <input type="file" className="form-control d-none" name={`video`} id={`introVideo-${index}`} accept=".mp4, .webm" onChange={(e) => handleSubjectMedia(e, subject, index)} required />
                                            <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a intro video.</div>
                                          </>
                                        )
                                      }
                                    </div>
                                  </div>
                                </div>
                                {subject.subjectMedia.video.files && <div className="row justify-content-center">
                                  <div className="col-auto">
                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("tribeSubject", "video", index, subject.subjectMedia.video.blobPath, subject.subjectMedia.video.files)}>
                                      <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                    </button>
                                  </div>
                                </div>}
                              </div>
                            </div>

                            <div className="row" style={((!subject.bannerDescription.replace(/<[^>]*>/g, '').trim() || !subject.subjectMedia.popupBanner.files) && subject.subjectMedia.video.files) ? { display: "none" } : {}}>
                              <div className="col-md-5">
                                <div className="form-group" >
                                  <div className="form-group">
                                    <h6 className='highlightMediaText'>Popup Image</h6>
                                    <div className="customImgUpload" style={{ backgroundColor: tribeData.tribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                      <div className="uploadBtn">
                                        {subject.subjectMedia.popupBanner.files ?
                                          <div className="w-100">
                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                              <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                <img src={subject.subjectMedia.popupBanner.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(subject.subjectMedia.popupBanner.files)} />
                                              </div>
                                            </div>

                                          </div>
                                          :
                                          <>
                                            <img className="noimage" src={"./assets/images/no-image-icon.png"} alt="" />
                                            <label htmlFor={`popup-banner-${index}`}>
                                              Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                            </label>
                                            <input type="file" className="form-control d-none" id={`popup-banner-${index}`} name="popupbanner" accept=".png, .jpg, .jpeg" onChange={(e) => handleSubjectMedia(e, subject, index)} required />
                                            <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload the banner.</div>
                                          </>
                                        }

                                      </div>
                                    </div>
                                  </div>
                                  {subject.subjectMedia.popupBanner.files && <div className="row justify-content-center">
                                    <div className="col-auto">
                                      <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("tribeSubject", "popupBanner", index, subject.subjectMedia.popupBanner.blobPath, subject.subjectMedia.popupBanner.files)} >
                                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                      </button>
                                    </div>
                                  </div>}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <h6 className='highlightMediaText'>Popup Description</h6>
                                  <ReactQuill className='whitebg' id={`bannerdescription-${index}`} value={subject.bannerDescription} onChange={(value) => handleSubjectInput("bannerDescription", value, index, "subject")}
                                    style={{ backgroundColor: tribeData.tribeSubject.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }} modules={{
                                      toolbar: [
                                        [{ header: [3, 4, false] }],
                                        ["bold", "italic", "underline", "blockquote"],
                                        [
                                          { list: "ordered" },
                                          { list: "bullet" },
                                          { indent: "-1" },
                                          { indent: "+1" }
                                        ],
                                        [{ align: [] }]
                                      ]
                                    }}
                                  />
                                </div>
                              </div>
                            </div>



                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Reward */}
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <h6 className='highlightMediaText'>Reward for completion <span className="text-danger">*</span></h6>
                    <input type="number" name="tribeReward" className="form-control" placeholder="Tribe Reward" value={tribeData.tribeReward > 0 ? tribeData.tribeReward : ''} onKeyDown={(e) => {
                      if (e.key === 'e' || e.key === 'E') {
                        e.preventDefault();
                      }
                    }} onChange={(event) => {
                      const value = event.target.value;
                      if (value.length > 4) return; // Prevent input if length exceeds 4
                      handleInputChange(event);
                    }} onWheel={(e: any) => e.target.blur()} required />

                    <div className="invalid-feedback" style={{ textAlign: "center" }}>Please provide a valid reward.</div>
                  </div>
                </div>
                <div className="col-md-6">

                  <div className="form-group">
                    <h6 className='highlightMediaText'>Tribe Status <span className="text-danger">*</span></h6>
                    <select className="form-select" name="tribeStatus" value={tribeData?.tribeStatus ?? ""} onChange={handleDropDown} required >
                      <option value="" disabled>
                        Select Tribe Status
                      </option>
                      <option value="2">Draft</option>
                      <option value="1">Publish</option>
                      <option value="0">Unpublish</option>

                    </select>
                    <div className="invalid-feedback" style={{ textAlign: "center" }}>Please select a status.</div>
                  </div>
                </div>
              </div>


              <div className="form-actions">
                <div className="row">
                  <div className="col-md-6">
                    <div className="btn-group w-100">
                      <button type="button" className="btn btn-save btnPurple" onClick={handleSubmit} disabled={message.errorMessage.length > 0 ? true : false}>Save</button>
                      {/* <button type="button" style={{ flex: '1 1 15%', border: "hidden" }} className="btn btnPurple dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                        <span className="visually-hidden">Toggle Dropdown</span>
                      </button>
                      <ul className="dropdown-menu" style={{ background: '#E9E4FF', borderRadius: '20' }}>
                        <li style={{ borderBottom: '3px solid #fff' }}><a className="dropdown-item" href="#">Publish</a></li>
                        <li><a className="dropdown-item" href="#">Save as draft</a></li>
                      </ul> */}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <button type="button" className="btn btn-cancel btnBorder" onClick={handleCancel}>Cancel</button>
                  </div>
                </div>
              </div>

            </Form>
          </div>

        </Offcanvas.Body>
        {loading.submitLoading &&
          <Loader message="Submitting Data..." />}
        {loading.fetchingLoading &&
          <Loader message="Fetching Data..." />}
        {loading.deleteLoading &&
          <Loader message="Deleting Data ..." />}
        {loading.validationLoading &&
          <Loader message="Validating Data ..." />}

      </Offcanvas>

      {show &&
        <ConfirmationPopup
          title={confirmationPopupData.title}
          message={confirmationPopupData.message}
          descriptions={confirmationPopupData.descriptions}
          isBackIterated={true}
          acceptText={confirmationPopupData.acceptText}
          cancelText={confirmationPopupData.cancelText}
          onAccept={confirmationPopupData.onAccept}
          onCancel={confirmationPopupData.onCancel}
          onCrossClick={confirmationPopupData.onCancel}
        />
      }
      {message.errorMessage.length > 0 &&
        <CustomAlert
          errorCount={message.errorMessage.length}
          messages={message.errorMessage}
          onClose={() => { setMessage({ ...message, errorMessage: [] }) }}
        />
      }
      <FullScreenLottieAnimation
        show={showPreview.animationShow}
        animationPath={previewSource}
        onClose={handleClosePreview}
      />
      <FullScreenImagePreview
        show={showPreview.imageShow}
        imagePath={previewSource}
        onClose={handleClosePreview}
      />



    </div>
  );
};

export default Tribe;
